import { Routes, Route, useLocation } from 'react-router-dom'
import { Component, useEffect } from 'react'
import Header from './components/Header.jsx'
import Footer from './components/Footer.jsx'
import Home from './pages/Home.jsx'
import Shop from './pages/Shop.jsx'
import Product from './pages/Product.jsx'
import HardwareFinishes from './pages/HardwareFinishes.jsx'
import HardwareFinish from './pages/HardwareFinish.jsx'
import CartPage from './pages/CartPage.jsx'
import Checkout from './pages/Checkout.jsx'
import Order from './pages/Order.jsx'
import Gallery from './pages/Gallery.jsx'
import About from './pages/About.jsx'
import Faq from './pages/Faq.jsx'
import HowToBuy from './pages/HowToBuy.jsx'
import DiyGuide from './pages/DiyGuide.jsx'
import Privacy from './pages/Privacy.jsx'
import Terms from './pages/Terms.jsx'
import Shipping from './pages/Shipping.jsx'
import Contact from './pages/Contact.jsx'
import Account from './pages/Account.jsx'
import Admin from './pages/Admin.jsx'

function ScrollToTop() {
  const { pathname } = useLocation()
  useEffect(() => window.scrollTo(0, 0), [pathname])
  return null
}

// Catches a render error in any page so one bad page can't blank the whole app
// (the site had no boundary — any throw unmounted everything to a white screen).
// Resets itself when the route changes, and shows the error so we can diagnose it.
class ErrorBoundary extends Component {
  state = { error: null }
  static getDerivedStateFromError(error) { return { error } }
  componentDidCatch(error, info) { console.error('Page render error:', error, info?.componentStack) }
  componentDidUpdate(prev) {
    if (this.state.error && prev.resetKey !== this.props.resetKey) this.setState({ error: null })
  }
  render() {
    if (!this.state.error) return this.props.children
    return (
      <main className="container page" style={{ maxWidth: 640, textAlign: 'center', padding: '64px 20px' }}>
        <h1>Something went wrong</h1>
        <p className="muted">Sorry — this page hit an error. Please reload, or go back to the homepage.</p>
        <div className="hero-actions" style={{ justifyContent: 'center', margin: '18px 0 26px' }}>
          <button className="btn btn-primary" onClick={() => window.location.reload()}>Reload page</button>
          <a className="btn btn-outline" href="/">Go to homepage</a>
        </div>
        <pre style={{
          textAlign: 'left', whiteSpace: 'pre-wrap', wordBreak: 'break-word',
          background: 'var(--bg-alt)', border: '1px solid var(--line)', borderRadius: 8,
          padding: '12px 14px', fontSize: 12, color: 'var(--ink-soft)', overflowX: 'auto',
        }}>{String(this.state.error?.message || this.state.error)}</pre>
      </main>
    )
  }
}

export default function App() {
  const { pathname } = useLocation()
  const isAdmin = pathname.startsWith('/admin')
  return (
    <>
      <ScrollToTop />
      {!isAdmin && <Header />}
      <ErrorBoundary resetKey={pathname}>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/shop" element={<Shop />} />
        <Route path="/shop/:category" element={<Shop />} />
        <Route path="/product/:sku" element={<Product />} />
        <Route path="/hardware" element={<HardwareFinishes />} />
        <Route path="/hardware/:finish" element={<HardwareFinish />} />
        <Route path="/cart" element={<CartPage />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/order/:id" element={<Order />} />
        <Route path="/account" element={<Account />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/about" element={<About />} />
        <Route path="/faq" element={<Faq />} />
        <Route path="/how-to-buy" element={<HowToBuy />} />
        <Route path="/diy-guide" element={<DiyGuide />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/shipping" element={<Shipping />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="*" element={<Home />} />
      </Routes>
      </ErrorBoundary>
      {!isAdmin && <Footer />}
    </>
  )
}
